export var MIGRATION_DEFAULT_BATCH_SIZE = 200;
//# sourceMappingURL=migration-helpers.js.map